import React, { useState, useContext } from 'react';
import { IconButton } from '@fluentui/react';
import { Certificate24Regular } from '@fluentui/react-icons';
import {
    Dialog,
    DialogSurface,
    DialogBody,
    DialogContent,
    DialogTrigger,
} from '@fluentui/react-components';
import ShiftsContext from '../../Context/ShiftsContext';
import QuizzesPage from '../Courses/QuizzesPage';

function Quizs() {
    const { unfinishedCourses } = useContext(ShiftsContext);
    const [open, setOpen] = useState(false);

    return (
        <div className="prelative">
            {(unfinishedCourses.length > 0) &&
                <span className="notification-bubble"></span>
            }
            <IconButton
                className="notification-icon"
                styles={{
                    root: { padding: '0 3px', marginRight: '3px', height: '100%', borderRadius: 0 },
                    label: { color: 'rgba(0, 0, 0, 0.87)' },
                    menuIcon: { display: 'none !important' }
                }}
                onClick={() => setOpen(true)}
            >
                <Certificate24Regular color='var(--colorNeutralForeground1)' />
            </IconButton>

            <Dialog open={open} onOpenChange={(e, data) => setOpen(data.open)} modalType="non-modal">
                <DialogSurface style={{
                    maxWidth: '100vw',
                    width: '100vw',
                    maxHeight: '100vh',
                    height: '100vh',
                    borderRadius: 0,
                    padding: 0,
                    margin: 0,
                    position: 'fixed',
                    top: 0,
                    left: 0,
                }}>
                    <DialogBody style={{ height: '100%', maxHeight: '100vh', padding: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column', gap:0 }}>
                        {/* Header */}
                        <div className="displayflex spacebetween" style={{ borderBottom: '1px solid var(--sub-nav-border-color)', backgroundColor: 'var(--white-to-grey)', flexShrink: 0, zIndex:1 }}>
                            <div className="displayflex aligncenter pl20">
                                <h4 className="head-s" style={{ fontSize: 19 }}>Quizzes & Lessons</h4>
                            </div>
                            <div className="">
                                <IconButton
                                    onClick={() => setOpen(false)}
                                    style={{ width: 55, height: 55 }}
                                    styles={{
                                        icon: { fontSize: 24 },
                                    }}
                                    iconProps={{
                                        iconName: 'Cancel'
                                    }}
                                />
                            </div>
                        </div>
                        {/* Content */}
                        <DialogContent style={{ flex: 1, padding: 0, overflow: 'hidden' }}>
                            <QuizzesPage />
                        </DialogContent>
                    </DialogBody>
                    <style>{`.fui-DialogSurface .layout__row { margin-left: 0 !important; }`}</style>
                </DialogSurface>
            </Dialog>
        </div>
    );
}

export { Quizs };
export default Quizs;


